<template>
  <div>
    <breadcrumbs  :adventure="adventure" :adventureId="adventureId" :chapter="selectedChapter" :chapterId="selectedChapterId"></breadcrumbs>
    <section id="page-chapters" class="mdl-grid adv-content" style="background-color: white; margin-top:20px;">
      <div class="mdl-cell mdl-cell--12-col mdl-grid">
        <div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet" >
          <table id="adv-table" class="mdl-data-table mdl-js-data-table mdl-shadow--2dp mdl-cell--12-col">
            <thead>
              <tr>
                <th class="mdl-data-table__cell--non-numeric"><i class="material-icons">collections_bookmark</i> Chapters</th>
                <th class="mdl-data-table__cell--non-numeric"><button @click="createChapter" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" style="position: absolute; top: 6px; right: 5px;">New Chapter</button></th>
              </tr>
            </thead>
            <tbody v-sortable >
              <tr v-for="(chapter, chapterKey) in adventure.chapters" :name="chapterKey" :class="selectionClass(chapterKey)" @click="selectChapter(chapterKey)">
                <td class="mdl-data-table__cell--non-numeric">{{chapter.name}}</td>
                <td class="mdl-data-table__cell--non-numeric"  style="text-align: right">
                <button :chapterKey="chapterKey" @click="deleteChapter" class="mdl-button mdl-js-button mdl-js-ripple-effect" >
                  <i :chapterKey="chapterKey" class="material-icons" >delete</i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mdl-cell mdl-cell--8-col mdl-cell--12-col-tablet mdl-grid" >
          <div v-if="selectedChapterId" class="mdl-cell mdl-cell--12-col mdl-grid" style="background-color: white; text-align: left;">
            <h5 class="mdl-cell--12-col">Edit Chapter</h5>
            <div class="mdl-cell--12-col">
              <div :class="{'is-dirty': selectedChapter.name}" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label ">
                <input class="mdl-textfield__input" type="text" id="sample1" :value="selectedChapter.name" @input='updateName'>
                <label class="mdl-textfield__label" for="sample1">Name...</label>
              </div>
            </div>
            <div class="mdl-cell--12-col">
              <div :class="{'is-dirty': selectedChapter.description}"  class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <textarea class="mdl-textfield__input" type="text" rows= "4" id="sample5" :value="selectedChapter.description" @input='updateDescription'></textarea>
                <label class="mdl-textfield__label" for="sample5">Description...</label>
              </div>
            </div>
            <div v-if="selectedChapter && selectedChapter.stages" class="mdl-cell--12-col">
              <div class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label">
                <select class="mdl-selectfield__select" id="initialStage" name="initialStage" @change="changeInitialStage" >
                  <option v-for="(stage, stageKey) in selectedChapter.stages" :value="stageKey" :selected="selectedChapter.initialStage===stageKey" value="stage">{{stage.name}}</option>
                </select>
                <label class="mdl-selectfield__label" for="objTypeLbl">Initial Stage</label>
                <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
              </div>
            </div>
            <div class="mdl-cell--12-col" id="chapterSections">
              <router-link style="margin: 5px;" :to="('/editor/'+adventureId+'/chapters/'+selectedChapterId+'/objects/')" 
                class="mdl-cell--4-col mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                <i class="material-icons">widgets</i> Objects</router-link> 
              <router-link style="margin: 5px;" :to="('/editor/'+adventureId+'/chapters/'+selectedChapterId+'/stages/')" 
                class="mdl-cell--4-col mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                <i class="material-icons">nature_people</i> Stages</router-link> 
              <router-link style="margin: 5px;" :to="('/editor/'+adventureId+'/chapters/'+selectedChapterId+'/timeline/')" 
                class="mdl-cell--4-col mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                <i class="material-icons">device_hub</i> Timeline</router-link>
            </div>         
          </div>
        </div>        
      </div>
    </section>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Sortable from 'vue-sortable';
  import Breadcrumbs from './Breadcrumbs.vue'

  Vue.use(Sortable)
  var sectionChapterEdit

  export default{
    components: {
      Breadcrumbs
    },
    data: ()=>({
      adventure: {
        name: "", 
        description: "",
        chapters: {}},
      adventureId: "",
      selectedChapterId: "",
      selectedChapter: {
        name: "", 
        description: ""},
      advRef: {},
      user: null
    }),
    created() {
      sectionChapterEdit = this;
      this.adventureId = this.$route.params.adventure;
      this.selectedChapterId  = this.$route.params.chapter;
      this.advRef = window.firebase.database().ref('adventures/'+this.adventureId);
      this.user = window.firebase.auth().currentUser;
      window.firebase.auth().onAuthStateChanged((user) => {
        sectionChapterEdit.user = user;
      });
      this.advRef.on('value', function(snapshot) {
        sectionChapterEdit.adventure = snapshot.val();
        if(sectionChapterEdit.adventure.chapters && Object.keys(sectionChapterEdit.adventure.chapters)[0]){
         if(!sectionChapterEdit.selectedChapterId || sectionChapterEdit.selectedChapterId===""){
            sectionChapterEdit.selectedChapterId = Object.keys(sectionChapterEdit.adventure.chapters)[0];          
          }
          sectionChapterEdit.selectedChapter = sectionChapterEdit.adventure.chapters[sectionChapterEdit.selectedChapterId];
        }
      });
    },
    firebase: {
    },
    methods: {
      selectionClass(chapterId){
        return chapterId === this.selectedChapterId ? "selected" : ""
      },
      selectChapter(chapterId){
        this.selectedChapterId = chapterId;
        this.selectedChapter = this.adventure.chapters[this.selectedChapterId];
      },
       updateName(e) {
        this.advRef.child('chapters').child(this.selectedChapterId).child('name').set(event.target.value)
      },
      updateDescription(e) {
        this.advRef.child('chapters').child(this.selectedChapterId).child('description').set(event.target.value)
      },
      createChapter(e){
        var newChapter = this.advRef.child('chapters').push({name: "Untitled Chapter", description: ""});
        this.selectChapter(newChapter.key);
      },
      deleteChapter(e){
        e.stopPropagation();
        var chapterId = e.target.attributes['chapterKey'].value;

        //delete files
        for(var stgId in this.adventure.chapters[chapterId].stages){
          if(this.adventure.chapters[chapterId].stages[stgId].bg){
            window.firebase.storage().ref(this.user.uid+"/"+this.adventureId+"/"+chapterId+"/stages/"+stgId+".png").delete();
          }
        }
        for(var objId in this.adventure.chapters[chapterId].objects){
          if(this.adventure.chapters[chapterId].objects[objId].bg){
            window.firebase.storage().ref(this.user.uid+"/"+this.adventureId+"/"+chapterId+"/objects/"+objId+".png").delete();
          }
        }

        if(chapterId===this.selectedChapterId){this.selectedChapterId = this.selectedChapter = null;}
        this.advRef.child('chapters').child(chapterId).remove();
      },
      changeInitialStage(event){
        var selectObj = event.target;
        var newValue = selectObj.options[selectObj.selectedIndex].value;
        this.advRef.child('chapters').child(this.selectedChapterId).child('initialStage').set(newValue);
        this.selectedStage.initialStage=newValue;
      }
    }
  }

</script>
<style>
  #chapterSections .mdl-button{
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// SectionChapters.vue?9c47a76e